import type { ReactNode } from 'react';

export interface FloatingFieldProps {
  /** ラベルテキスト */
  label: string;
  /** フィールドのID（labelのfor属性に使用） */
  htmlFor?: string;
  /** 必須マークを表示するか */
  required?: boolean;
  /** サポートテキスト */
  supportText?: string;
  /** エラーテキスト */
  errorText?: string;
  /** エラー状態かどうか（trueの場合、エラーテキストを表示） */
  hasError?: boolean;
  /** data-column属性（グリッドのカラム数） */
  column?: '2' | 'full';
  /** 子要素（input等） */
  children: ReactNode;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * AIPデザインシステムのフローティングラベルフィールドコンポーネント
 */
export const FloatingField: React.FC<FloatingFieldProps> = ({
  label,
  htmlFor,
  required,
  supportText,
  errorText,
  hasError,
  column,
  children,
  className = '',
}) => {
  const dataAttributes: Record<string, string | undefined> = {};
  if (column) {
    dataAttributes['data-column'] = column;
  }

  // hasErrorが明示的に指定されている場合はそれを使用、そうでなければerrorTextの有無で判定
  const showError = hasError !== undefined ? hasError : !!errorText;

  return (
    <div className={`aip-floating-field ${className}`.trim()} {...dataAttributes}>
      <label className="aip-floating-field__label" htmlFor={htmlFor}>
        {label}
        {required && <span className="aip-floating-field__required-mark">※必須</span>}
      </label>
      {children}
      {supportText && !showError && (
        <div className="aip-floating-field__support-text">{supportText}</div>
      )}
      {errorText && showError && (
        <div className="aip-floating-field__error-text" role="alert">
          {errorText}
        </div>
      )}
    </div>
  );
};

export default FloatingField;

